











import { Component, Vue, Prop } from 'vue-property-decorator'
import { GamePlayer } from '@/class/gamePlayer'

export interface StatusIconsComponentInterface {
  player: GamePlayer;
  showsBomb: boolean;
  showsCrab: boolean;
  showsGuard: boolean;
  showsTempt: boolean;
  showsScammed: boolean;
  showsStolen: boolean;
}

@Component
export default class PlayerListItem extends Vue {
  @Prop() data!: StatusIconsComponentInterface;
}
